import React from "react";
import { InputNumber, Slider, Tooltip } from "antd";
import Utils from "@/utils";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowUpIcon } from "@/assets/icons/arrow-up.svg";
import { ReactComponent as DeleteIcon } from "@/assets/icons/delete.svg";
import { ReactComponent as FadeInOutIcon } from "@/assets/icons/fade-in-out.svg";
import { ReactComponent as FadeInIcon } from "@/assets/icons/fade-in.svg";
import { ReactComponent as FadeOutIcon } from "@/assets/icons/fade-out.svg";

import "@/assets/audioJoiner.less";

const AudioJoinerWorkListItemRender = ({
  active,
  index,
  audioJoinerItem,
  audioJoinerList,
  wavesurferRef,
  currentTime,
  currentTimePercent,
  getCutPercent,
  handleChangeSort,
  handleFade,
  handleSelected,
  handleSliderTips,
  handleDeleteAudioJoinerItem,
  handleCurrentTimeChange,
  handleRangeChange,
  handleTimeChange,
}) => {
  const { t } = useTranslation(["audioJoiner", "common"]);
  let startRef = React.createRef();
  let endRef = React.createRef();
  let currTimeRef = React.createRef();
  let rangeRef = React.createRef();
  console.log("更新");
  return (
    <div className={`audio-joiner-item ${active ? "active" : ""} `} onClick={handleSelected}>
      <p className="audio-joiner-item-name">{Utils.omissionString(audioJoinerItem.name, 6, 6)}</p>
      <div className="waveform" ref={wavesurferRef}>
        {index === 0 ? (
          <Tooltip placement="top" title={t("Fade in")} overlayStyle={{ fontSize: 12 }}>
            <span className={`fade-icon left ${audioJoinerItem.fadeIn ? "active" : ""}`} onClick={() => handleFade("in")}>
              <FadeInIcon />
            </span>
          </Tooltip>
        ) : null}
        {index < audioJoinerList.length - 1 ? (
          <Tooltip placement="top" title={t("Fade out")} overlayStyle={{ fontSize: 12 }}>
            <span className={`fade-icon right ${audioJoinerItem.fadeOut ? "active" : ""}`} onClick={() => handleFade("out")}>
              <FadeInOutIcon />
            </span>
          </Tooltip>
        ) : (
          <Tooltip placement="top" title={t("Fade out")} overlayStyle={{ fontSize: 12 }}>
            <span className={`fade-icon right ${audioJoinerItem.fadeOut ? "active" : ""}`} onClick={() => handleFade("out")}>
              <FadeOutIcon />
            </span>
          </Tooltip>
        )}
        <div className="rgt-operation">
          {audioJoinerList.length > 1 ? (
            <ArrowUpIcon
              onClick={e => handleChangeSort(e, "up", index)}
              className="arrow-icon"
              style={index === 0 ? { color: "#5E5F62", cursor: "not-allowed" } : {}}
            />
          ) : null}
          <DeleteIcon onClick={() => handleDeleteAudioJoinerItem(audioJoinerItem.guid)} />
          {audioJoinerList.length > 1 ? (
            <ArrowUpIcon
              onClick={e => handleChangeSort(e, "down", index)}
              className="arrow-icon"
              style={index >= audioJoinerList.length - 1 ? { color: "#5E5F62", cursor: "not-allowed" } : {}}
            />
          ) : null}
        </div>
        <div className="frame" id="frame" style={!active ? { visibility: "hidden" } : {}} ref={currTimeRef}>
          <Slider
            step={0.01}
            value={currentTimePercent}
            tipFormatter={() => currentTime}
            tooltipVisible={active}
            tooltipPlacement="top"
            getTooltipPopupContainer={() => (currTimeRef ? currTimeRef.current : document.body)}
            onChange={handleCurrentTimeChange}
          />
        </div>
        <div className="range" id="range" ref={rangeRef}>
          <Slider
            step={0.01}
            range={{ draggableTrack: true }}
            value={[getCutPercent(audioJoinerItem.start), getCutPercent(audioJoinerItem.end)]}
            tipFormatter={value => handleSliderTips(value)}
            tooltipVisible={active}
            tooltipPlacement="bottom"
            getTooltipPopupContainer={() => (rangeRef ? rangeRef.current : document.body)}
            onChange={handleRangeChange}
          />
          <div
            className="cover"
            style={{
              left: 0,
              width: getCutPercent(audioJoinerItem.start) + "%",
            }}
          ></div>
          <div
            className="cover"
            style={{
              left: getCutPercent(audioJoinerItem.end) + "%",
              width: 100 - getCutPercent(audioJoinerItem.end) + "%",
            }}
          ></div>
          <div
            className="include"
            style={{
              left: Math.round(getCutPercent(audioJoinerItem.start)) + "%",
              width: Math.round(getCutPercent(audioJoinerItem.end)) - Math.round(getCutPercent(audioJoinerItem.start)) + "%",
            }}
          ></div>
        </div>
      </div>
      <div className="audio-operation">
        <div className="audio-operation-time">
          <div>
            <span className="label">{t("common:Start")}</span>
            <InputNumber
              ref={startRef}
              value={audioJoinerItem.start}
              formatter={() => audioJoinerItem.start}
              onStep={value => handleTimeChange(value, "start")}
              step={0.01}
              onFocus={() => {
                if (startRef.current && !startRef.current.disabled) {
                  startRef.current.disabled = true;
                }
              }}
            />
          </div>
          <div>
            <span className="label">{t("common:End")}</span>
            <InputNumber
              ref={endRef}
              value={audioJoinerItem.end}
              formatter={() => audioJoinerItem.end}
              onStep={value => handleTimeChange(value, "end")}
              step={0.01}
              onFocus={() => {
                if (endRef.current && !endRef.current.disabled) {
                  endRef.current.disabled = true;
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioJoinerWorkListItemRender;
